<template>
  <CarrosselWizard
    tipo-conteudo="PRODUCT_CATEGORY"
    :product-editor-mode="true"
    carousel-type-variant="type1"
  />
</template>

<script>
import CarrosselWizard from "../carrossel/CarrosselWizard.vue";

export default {
  name: "VitrineWizard",
  components: {
    CarrosselWizard
  }
};
</script>
